import React, { useCallback } from "react";
import { Portal } from "react-portal";
import I32Cross from "assets/icons/I32Cross";
import OutsideClickHandler from "components/OutsideClickHandler";
import { Container, Content, ExitButton } from "./styles";

type Props = {
  children: React.ReactNode;
  onClose: () => void;
  canCloseByOuterClick?: boolean;
  withoutExitButton?: boolean;
  exitButtonZIndex?: number;
  exitButtonColor?: string;
};

const Popup = ({
  children,
  onClose,
  canCloseByOuterClick,
  withoutExitButton,
  exitButtonZIndex,
  exitButtonColor,
}: Props) => {
  const onClickOutside = useCallback(() => {
    canCloseByOuterClick && onClose();
  }, [canCloseByOuterClick, onClose]);

  return (
    <Portal>
      <Container>
        <OutsideClickHandler onClick={onClickOutside}>
          <Content>
            {!withoutExitButton && (
              <ExitButton
                icon={<I32Cross color={exitButtonColor} />}
                onClick={onClose}
                exitButtonZIndex={exitButtonZIndex}
              />
            )}
            {children}
          </Content>
        </OutsideClickHandler>
      </Container>
    </Portal>
  );
};

export default Popup;
